module.exports = __webpack_public_path__ + "img/icon_today_account.ebae1a4f.png";